import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'
import { useUsersStore } from '@/stores/users'

export const useUserGroupStore = defineStore('user-group', () => {

    const configStore = useConfigStore()
    const requestsStore = useRequestsStore()
    const tokenStore = useTokenStore()
    const usersStore = useUsersStore()

    const userGroup = ref({})
    const userGroupProcess = ref(false)
    const userGroupMsg = ref({})

    const userGroupsList = ref({})
    const userGroupsListProcess = ref(false)
    const userGroupsListMsg = ref({})

    const userGroupUpdateProcess = ref(false)
    const userGroupUpdateMsg = ref({})

    const userGroupDeleteProcess = ref(false)
    const userGroupDeleteMsg = ref({})

    async function readUserGroup(payload) {

        userGroupProcess.value = true
        const token = tokenStore.access

        if(token) {
            
            let params = ''

            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/ugroups${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error && request.array?.length) {
                userGroup.value = request.array[0]
            } else {
                userGroup.value = {}
            }
        
        } else {
            userGroupMsg.value = { success: false, text: 'EToken' }
        }

        userGroupProcess.value = false
        return userGroup.value
    }

    async function readUserGroups(payload) {

        userGroupsListProcess.value = true
        const token = tokenStore.access

        if(token) {
            
            let params = ''

            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/ugroups${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                userGroupsList.value = request
            } else {
                userGroupsList.value = {}
                userGroupsListMsg.value = { success: false, text: request.error }
            }

        } else {
            userGroupsListMsg.value = { success: false, text: 'EToken' }
        }

        userGroupsListProcess.value = false
        return userGroupsList.value
    }

    async function updateUserGroup(payload) {

        userGroupUpdateProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/ugroups`, 
                method: 'PUT', 
                token,
                data: payload
            })

            if(!request.error) {
                usersStore.setUser(request)
                userGroupUpdateMsg.value = { success: true, text: 'USER_GROUP_UPDATE_SUCCESS' }
            } else {
                userGroupUpdateMsg.value = { success: false, text: request.error }
            }

        } else {
            userGroupUpdateMsg.value = { success: false, text: 'EToken' }
        }

        userGroupUpdateProcess.value = false
    }

    const setUserGroup          = data => userGroup.value            = data
    const setUserGroupUpdateMsg = data => userGroupUpdateMsg.value   = data

    return {

        userGroup,
        userGroupProcess,
        userGroupMsg,
        userGroupsList,
        userGroupsListProcess,
        userGroupsListMsg,
        userGroupUpdateProcess,
        userGroupUpdateMsg,
        userGroupDeleteProcess,
        userGroupDeleteMsg,
        readUserGroup,
        readUserGroups,
        updateUserGroup,
        setUserGroup,
        setUserGroupUpdateMsg
    }
})
